/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LeadSurvey_viewer$ref: FragmentReference;
declare export opaque type LeadSurvey_viewer$fragmentType: LeadSurvey_viewer$ref;
export type LeadSurvey_viewer = {|
  +leadSurvey: ?{|
    +id: string,
    +plainId: ?string,
    +title: ?string,
    +description: ?string,
    +pages: ?$ReadOnlyArray<?{|
      +id: string,
      +plainId: ?string,
      +title: ?string,
      +description: ?string,
      +displayOrder: ?number,
      +items: ?$ReadOnlyArray<?{|
        +id: string,
        +plainId: ?string,
        +title: ?string,
        +description: ?string,
        +displayOrder: ?number,
        +type: ?string,
        +answerRequired: ?boolean,
        +answers: ?$ReadOnlyArray<?{|
          +id: string,
          +plainId: ?string,
          +displayOrder: ?number,
          +type: ?string,
          +dataType: ?string,
          +title: ?string,
        |}>,
        +otherAnswerAdd: ?string,
        +otherAnswerDisplayType: ?string,
        +otherAnswer: ?{|
          +id: string,
          +plainId: ?string,
          +type: ?string,
          +dataType: ?string,
          +title: ?string,
        |},
      |}>,
    |}>,
  |},
  +$refType: LeadSurvey_viewer$ref,
|};
export type LeadSurvey_viewer$data = LeadSurvey_viewer;
export type LeadSurvey_viewer$key = {
  +$data?: LeadSurvey_viewer$data,
  +$fragmentRefs: LeadSurvey_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "plainId",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayOrder",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dataType",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "LeadSurvey_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "leadType",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "leadSurvey",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "leadType",
          "variableName": "leadType"
        }
      ],
      "concreteType": "Survey",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pages",
          "storageKey": null,
          "args": null,
          "concreteType": "SurveyPage",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "SurveyItem",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "answerRequired",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "answers",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SurveyItemAnswer",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v4/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v2/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "otherAnswerAdd",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "otherAnswerDisplayType",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "otherAnswer",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SurveyItemAnswer",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v5/*: any*/),
                    (v6/*: any*/),
                    (v2/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '7dcb1b37b3e8e40381af7de33ec819cf';
module.exports = node;
